// // // import { Component, AfterViewInit, ElementRef, ViewChildren, QueryList, OnInit, HostListener } from '@angular/core';
// // // import { RouterLink } from '@angular/router';
// // // import { HttpClient, HttpHeaders } from '@angular/common/http';
// // // import { Router } from '@angular/router';
// // // // import { url } from 'inspector';
// // // // import { ElementRef } from '@angular/core';
// // // import { NgxSpinnerService } from "ngx-spinner";
// // // import { LoadingScreenComponent } from 'src/app/shared/loading-screen/loading-screen.component';
// // // import { LoadingScreenService } from 'src/app/shared/loading-screen/loading-screen.service';
// // // import Swal from 'sweetalert2';

// // // @Component({
// // //   selector: 'app-land',
// // //   templateUrl: './land.component.html',
// // //   styleUrls: ['./land.component.css']
// // // })

// // // export class LandComponent implements OnInit, AfterViewInit {
// // //   @ViewChildren('divider') dividers!: QueryList<ElementRef>;
// // //   @ViewChildren('statsNumber') statsNumbers!: QueryList<ElementRef>;
// // //   @ViewChildren('eurekaHeading') eurekaHeadings!: QueryList<ElementRef>;

// // //   screen: boolean = true;
// // //   displayStyles: any;

// // //   constructor(private http: HttpClient, private router: Router, private SpinnerService: LoadingScreenService) { }

// // //   ngOnInit(): void {
// // //     this.displayStyles = "block";
// // //     setTimeout(() => {
// // //       this.displayStyles = "none";
// // //     }, 3000);
// // //     if (window.innerWidth < 768) {
// // //       this.screen = false;
// // //     }
// // //   }

// // //   @HostListener('window:scroll', ['$event'])
// // //   onWindowScroll() {
// // //     const scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
// // //     if (scroll <= 300) {
// // //       $('.nav-home').css({
// // //         background: 'transparent',
// // //       });
// // //     } else {
// // //       $('.nav-home').css({
// // //         background: '#04070A',
// // //       });
// // //     }
// // //   }

// // //   @HostListener('window:resize', ['$event'])
// // //   onResize(event: any) {
// // //     if (event.target.innerWidth < 768) {
// // //       this.screen = false;
// // //     } else {
// // //       this.screen = true;
// // //     }
// // //   }

// // //   register() {
// // //     this.router.navigateByUrl('/reg');
// // //   }

// // //   ngAfterViewInit() {
// // //     const observer = new IntersectionObserver((entries) => {
// // //       entries.forEach(entry => {
// // //         if (entry.isIntersecting) {
// // //           entry.target.classList.add('visible');
// // //           entry.target.classList.remove('invisible');
// // //           if (entry.target.classList.contains('stats-number')) {
// // //             this.startCounting(entry.target as HTMLElement);
// // //           }
// // //         } else {
// // //           entry.target.classList.remove('visible');
// // //           entry.target.classList.add('invisible');
// // //         }
// // //       });
// // //     }, { threshold: 0.1 });

// // //     this.dividers.forEach(divider => {
// // //       observer.observe(divider.nativeElement);
// // //     });

// // //     this.statsNumbers.forEach(number => {
// // //       observer.observe(number.nativeElement);
// // //     });

// // //     this.eurekaHeadings.forEach(heading => {
// // //       observer.observe(heading.nativeElement);
// // //     });
// // //   }

// // //   private startCounting(element: HTMLElement): void {
// // //     const text = element.innerText;
// // //     const match = text.match(/[\d,]+/g); // Extract numeric part including commas
// // //     const endValueString = match ? match[0].replace(/,/g, '') : '0'; // Remove commas for parsing
// // //     const endValue = parseInt(endValueString, 10) || 0;

// // //     let startValue = 0;
// // //     const duration = 2000; // Duration in milliseconds
// // //     const stepTime = 50; // Time interval in milliseconds
// // //     const increment = endValue / (duration / stepTime); // Increment every stepTime milliseconds

// // //     const interval = setInterval(() => {
// // //       startValue += increment;
// // //       if (startValue >= endValue) {
// // //         clearInterval(interval);
// // //         startValue = endValue; // Ensure we reach exactly the end value
// // //       }

// // //       const formattedValue = Math.floor(startValue).toLocaleString();
// // //       element.innerText = text.replace(/[\d,]+/, formattedValue); // Update numeric part only
// // //     }, stepTime);
// // //   }

// // // }

// // import { Component, AfterViewInit, ElementRef, ViewChildren, QueryList, OnInit, HostListener } from '@angular/core';
// // import { Router } from '@angular/router';
// // import { HttpClient } from '@angular/common/http';
// // import { LoadingScreenService } from 'src/app/shared/loading-screen/loading-screen.service';

// // @Component({
// //   selector: 'app-land',
// //   templateUrl: './land.component.html',
// //   styleUrls: ['./land.component.css']
// // })

// // export class LandComponent implements OnInit, AfterViewInit {
// //   @ViewChildren('divider') dividers!: QueryList<ElementRef>;
// //   @ViewChildren('statsNumber') statsNumbers!: QueryList<ElementRef>;
// //   @ViewChildren('eurekaHeading') eurekaHeadings!: QueryList<ElementRef>;

// //   screen: boolean = true;
// //   displayStyles: any;

// //   constructor(private http: HttpClient, private router: Router, private SpinnerService: LoadingScreenService) { }

// //   ngOnInit(): void {
// //     this.displayStyles = "block";
// //     setTimeout(() => {
// //       this.displayStyles = "none";
// //     }, 3000);
// //     if (window.innerWidth < 768) {
// //       this.screen = false;
// //     }
// //   }

// //   @HostListener('window:scroll', ['$event'])
// //   onWindowScroll() {
// //     const scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
// //     if (scroll <= 300) {
// //       $('.nav-home').css({
// //         background: 'transparent',
// //       });
// //     } else {
// //       $('.nav-home').css({
// //         background: '#04070A',
// //       });
// //     }
// //   }

// //   @HostListener('window:resize', ['$event'])
// //   onResize(event: any) {
// //     if (event.target.innerWidth < 768) {
// //       this.screen = false;
// //     } else {
// //       this.screen = true;
// //     }
// //   }

// //   register() {
// //     this.router.navigateByUrl('/reg');
// //   }

// //   ngAfterViewInit() {
// //     const observer = new IntersectionObserver((entries) => {
// //       entries.forEach(entry => {
// //         if (entry.isIntersecting) {
// //           entry.target.classList.add('visible');
// //           entry.target.classList.remove('invisible');
// //           if (entry.target.classList.contains('stats-number')) {
// //             this.startCounting(entry.target as HTMLElement);
// //           }
// //         } else {
// //           entry.target.classList.remove('visible');
// //           entry.target.classList.add('invisible');
// //         }
// //       });
// //     }, { threshold: 0.1 });

// //     // Observe dividers
// //     this.dividers.forEach(divider => {
// //       observer.observe(divider.nativeElement);
// //       // Trigger immediately if in view on load
// //       this.checkVisibilityAndTrigger(divider.nativeElement, observer);
// //     });

// //     // Observe stats numbers
// //     this.statsNumbers.forEach(number => {
// //       observer.observe(number.nativeElement);
// //       // Trigger immediately if in view on load
// //       this.checkVisibilityAndTrigger(number.nativeElement, observer);
// //     });

// //     // Observe headings
// //     this.eurekaHeadings.forEach(heading => {
// //       observer.observe(heading.nativeElement);
// //       // Trigger immediately if in view on load
// //       this.checkVisibilityAndTrigger(heading.nativeElement, observer);
// //     });
// //   }

// //   private checkVisibilityAndTrigger(element: HTMLElement, observer: IntersectionObserver) {
// //     const rect = element.getBoundingClientRect();
// //     const inViewport = rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);

// //     if (inViewport) {
// //       observer.unobserve(element); // Stop observing if it's already in view
// //       element.classList.add('visible');
// //       element.classList.remove('invisible');
// //       if (element.classList.contains('stats-number')) {
// //         this.startCounting(element);
// //       }
// //     }
// //   }

// //   private startCounting(element: HTMLElement): void {
// //     const text = element.innerText;
// //     const match = text.match(/[\d,]+/g); // Extract numeric part including commas
// //     const endValueString = match ? match[0].replace(/,/g, '') : '0'; // Remove commas for parsing
// //     const endValue = parseInt(endValueString, 10) || 0;

// //     let startValue = 0;
// //     const duration = 2000; // Duration in milliseconds
// //     const stepTime = 50; // Time interval in milliseconds
// //     const increment = endValue / (duration / stepTime); // Increment every stepTime milliseconds

// //     const interval = setInterval(() => {
// //       startValue += increment;
// //       if (startValue >= endValue) {
// //         clearInterval(interval);
// //         startValue = endValue; // Ensure we reach exactly the end value
// //       }

// //       const formattedValue = Math.floor(startValue).toLocaleString();
// //       element.innerText = text.replace(/[\d,]+/, formattedValue); // Update numeric part only
// //     }, stepTime);
// //   }
// // }

// import { Component, AfterViewInit, ElementRef, ViewChildren, QueryList, OnInit, HostListener } from '@angular/core';
// import { Router } from '@angular/router';
// import { HttpClient } from '@angular/common/http';
// import { LoadingScreenService } from 'src/app/shared/loading-screen/loading-screen.service';

// @Component({
//   selector: 'app-land',
//   templateUrl: './land.component.html',
//   styleUrls: ['./land.component.css']
// })

// export class LandComponent implements OnInit, AfterViewInit {
//   @ViewChildren('divider') dividers!: QueryList<ElementRef>;
//   @ViewChildren('statsNumber') statsNumbers!: QueryList<ElementRef>;
//   @ViewChildren('eurekaHeading') eurekaHeadings!: QueryList<ElementRef>;

//   screen: boolean = true;
//   displayStyles: any;

//   constructor(private http: HttpClient, private router: Router, private SpinnerService: LoadingScreenService) { }

//   ngOnInit(): void {
//     this.displayStyles = "block";
//     setTimeout(() => {
//       this.displayStyles = "none";
//     }, 3000);
//     if (window.innerWidth < 768) {
//       this.screen = false;
//     }
//   }

//   @HostListener('window:scroll', ['$event'])
//   onWindowScroll() {
//     const scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
//     if (scroll <= 300) {
//       $('.nav-home').css({
//         background: 'transparent',
//       });
//     } else {
//       $('.nav-home').css({
//         background: '#04070A',
//       });
//     }
//   }

//   @HostListener('window:resize', ['$event'])
//   onResize(event: any) {
//     if (event.target.innerWidth < 768) {
//       this.screen = false;
//     } else {
//       this.screen = true;
//     }
//   }

//   register() {
//     this.router.navigateByUrl('/reg');
//   }

//   ngAfterViewInit() {
//     const observer = new IntersectionObserver((entries) => {
//       entries.forEach(entry => {
//         if (entry.isIntersecting) {
//           entry.target.classList.add('visible');
//           entry.target.classList.remove('invisible');
//           if (entry.target.classList.contains('stats-number')) {
//             this.startCounting(entry.target as HTMLElement);
//           }
//         } else {
//           entry.target.classList.remove('visible');
//           entry.target.classList.add('invisible');
//         }
//       });
//     }, { threshold: 0.1 });

//     // Observe dividers
//     this.dividers.forEach(divider => {
//       observer.observe(divider.nativeElement);
//     });

//     // Observe stats numbers and start counting immediately if in view
//     this.statsNumbers.forEach(number => {
//       observer.observe(number.nativeElement);
//       this.triggerCountingIfInView(number.nativeElement, observer);
//     });

//     // Observe headings
//     this.eurekaHeadings.forEach(heading => {
//       observer.observe(heading.nativeElement);
//     });
//   }

//   private triggerCountingIfInView(element: HTMLElement, observer: IntersectionObserver) {
//     const rect = element.getBoundingClientRect();
//     const inViewport = rect.top < window.innerHeight && rect.bottom > 0;

//     if (inViewport) {
//       element.classList.add('visible');
//       element.classList.remove('invisible');
//       if (element.classList.contains('stats-number')) {
//         observer.unobserve(element); // Stop observing since it's already in view
//         this.startCounting(element);
//       }
//     }
//   }

//   private startCounting(element: HTMLElement): void {
//     const text = element.innerText;
//     const match = text.match(/[\d,]+/g); // Extract numeric part including commas
//     const endValueString = match ? match[0].replace(/,/g, '') : '0'; // Remove commas for parsing
//     const endValue = parseInt(endValueString, 10) || 0;

//     let startValue = 0;
//     const duration = 2000; // Duration in milliseconds
//     const stepTime = 50; // Time interval in milliseconds
//     const increment = endValue / (duration / stepTime); // Increment every stepTime milliseconds

//     const interval = setInterval(() => {
//       startValue += increment;
//       if (startValue >= endValue) {
//         clearInterval(interval);
//         startValue = endValue; // Ensure we reach exactly the end value
//       }

//       const formattedValue = Math.floor(startValue).toLocaleString();
//       element.innerText = text.replace(/[\d,]+/, formattedValue); // Update numeric part only
//     }, stepTime);
//   }
// }

import {
  Component,
  AfterViewInit,
  ElementRef,
  ViewChildren,
  QueryList,
  OnInit,
  HostListener,
} from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { LoadingScreenService } from "src/app/shared/loading-screen/loading-screen.service";

@Component({
  selector: "app-land",
  templateUrl: "./land.component.html",
  styleUrls: ["./land.component.css"],
})
export class LandComponent implements OnInit, AfterViewInit {
  @ViewChildren("divider") dividers!: QueryList<ElementRef>;
  @ViewChildren("statsNumber") statsNumbers!: QueryList<ElementRef>;
  @ViewChildren("eurekaHeading") eurekaHeadings!: QueryList<ElementRef>;

  screen: boolean = true;
  displayStyles: any;

  constructor(
    private http: HttpClient,
    private router: Router,
    private SpinnerService: LoadingScreenService
  ) {}

  ngOnInit(): void {
    this.displayStyles = "block";
    setTimeout(() => {
      this.displayStyles = "none";
    }, 3000);
    if (window.innerWidth < 768) {
      this.screen = false;
    }
  }

  @HostListener("window:scroll", ["$event"])
  onWindowScroll() {
    const scroll =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    if (scroll <= 300) {
      $(".nav-home").css({
        background: "transparent",
      });
    } else {
      $(".nav-home").css({
        background: "#04070A",
      });
    }
  }

  @HostListener("window:resize", ["$event"])
  onResize(event: any) {
    if (event.target.innerWidth < 768) {
      this.screen = false;
    } else {
      this.screen = true;
    }
  }

  register() {
    this.router.navigateByUrl("/reg");
  }

  // ngAfterViewInit() {
  //   const observer = new IntersectionObserver((entries) => {
  //     entries.forEach(entry => {
  //       if (entry.isIntersecting) {
  //         entry.target.classList.add('visible');
  //         entry.target.classList.remove('invisible');
  //         if (entry.target.classList.contains('stats-number')) {
  //           this.startCounting(entry.target as HTMLElement);
  //         }
  //       } else {
  //         // Reset the number animation if it goes out of view
  //         if (entry.target.classList.contains('stats-number')) {
  //           this.resetCounting(entry.target as HTMLElement);
  //         }
  //         entry.target.classList.remove('visible');
  //         entry.target.classList.add('invisible');
  //       }
  //     });
  //   }, { threshold: 0.1 });

  //   this.dividers.forEach(divider => {
  //     observer.observe(divider.nativeElement);
  //   });

  //   this.statsNumbers.forEach(number => {
  //     observer.observe(number.nativeElement);
  //   });

  //   this.eurekaHeadings.forEach(heading => {
  //     observer.observe(heading.nativeElement);
  //   });
  // }

  // ngAfterViewInit() {
  //   const observer = new IntersectionObserver((entries) => {
  //     entries.forEach(entry => {
  //       if (entry.isIntersecting) {
  //         entry.target.classList.add('visible');
  //         entry.target.classList.remove('invisible');
  //         if (entry.target.classList.contains('stats-number')) {
  //           this.startCounting(entry.target as HTMLElement);
  //         }
  //       } else {
  //         // Reset the number animation if it goes out of view
  //         if (entry.target.classList.contains('stats-number')) {
  //           // this.resetCounting(entry.target as HTMLElement);
  //         }
  //         // entry.target.classList.remove('visible');
  //         // entry.target.classList.add('invisible');
  //       }
  //     });
  //   }, { threshold: 0.1 });

  //   this.dividers.forEach(divider => {
  //     observer.observe(divider.nativeElement);
  //   });

  //   this.statsNumbers.forEach(number => {
  //     observer.observe(number.nativeElement);
  //   });

  //   this.eurekaHeadings.forEach(heading => {
  //     observer.observe(heading.nativeElement);
  //   });

  // }

  ngAfterViewInit() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            entry.target.classList.remove("invisible");
            if (entry.target.classList.contains("stats-number")) {
              this.startCounting(entry.target as HTMLElement);
            }
          } else {
            // Reset the number animation if it goes out of view
            if (entry.target.classList.contains("stats-number")) {
              // this.resetCounting(entry.target as HTMLElement);
            }
            // entry.target.classList.remove('visible');
            // entry.target.classList.add('invisible');
          }
        });
      },
      { threshold: 0.1 }
    );

    // Observe all elements with the #eurekaHeading directive
    this.eurekaHeadings.forEach((heading) => {
      observer.observe(heading.nativeElement);
    });

    this.dividers.forEach((divider) => {
      observer.observe(divider.nativeElement);
    });

    this.statsNumbers.forEach((number) => {
      observer.observe(number.nativeElement);
    });
  }

  private startCounting(element: HTMLElement): void {
    const text = element.innerText;
    const match = text.match(/[\d,]+/g);
    const endValueString = match ? match[0].replace(/,\./g, "") : "0";
    const endValue =
      parseInt(
        element.attributes.getNamedItem("data-number")?.value ?? "",
        10
      ) || 0;

    let startValue = 0;
    const duration = 1000;
    const stepTime = 50;
    const increment = endValue / (duration / stepTime);

    const interval = setInterval(() => {
      startValue += increment;
      if (startValue >= endValue) {
        clearInterval(interval);
        startValue = endValue;
      }

      // Use 0.1f representation if end val is very small
      const formattedValue =
        endValue < 3
          ? startValue.toFixed(1)
          : Math.floor(startValue).toLocaleString();
      element.innerText = text.replace(/[\d,\.]+/, formattedValue);
    }, stepTime);
    // new change
    element.classList.add("visible");
  }

  // private resetCounting(element: HTMLElement): void {
  //   // Optionally reset the text content if you want to start from zero again
  //   const text = element.innerText;
  //   element.innerText = text.replace(/[\d,]+/, '0');
  // }
  // private resetCounting(element: HTMLElement): void {
  //   // Optionally reset the text content if you want to start from zero again
  //   element.innerText = '0';
  //   // Remove the visible class and re-add it to restart animation
  //   element.classList.remove('visible');
  //   void element.offsetWidth; // Trigger a reflow
  //   element.classList.add('visible');
}
